export default __webpack_public_path__ + "static/media/wines-row.f3629fe9.jpg";